import { createShader, colorUniform } from "./ShaderBase.js";

export const galaxyShader = createShader({
  customizable: [
    { uniform: "uColorVoid", label: "Void", default: "#0a0015" },
    { uniform: "uColorNebula", label: "Nebula", default: "#2d1b4e" },
  ],

  uniforms: {
    uPixelSize: { value: 12.0 },
    uScale: { value: 0.5 },
    uSpeed: { value: 0.1 },
    uColorVoid: colorUniform("#0a0015"),
    uColorNebula: colorUniform("#2d1b4e"),
    uColorStars: colorUniform("#ffffff"),
    uColorAccent: colorUniform("#4a2c7a"),
    uStarDensity: { value: 0.94 },
  },

  fragmentUniforms: `
    uniform vec3 uColorVoid;
    uniform vec3 uColorNebula;
    uniform vec3 uColorStars;
    uniform vec3 uColorAccent;
    uniform float uStarDensity;
  `,

  fragmentBody: `
    // Deep space base
    vec3 color = uColorVoid;

    // Nebula clouds - slow drifting movement
    vec3 nebulaPos = pixelatedPos * uScale + vec3(
      uTime * 0.04,
      uTime * 0.025,
      uTime * 0.03
    );
    float nebula1 = snoise(nebulaPos * 0.8);
    float nebula2 = snoise(nebulaPos * 1.5 + vec3(50.0));
    float nebula = (nebula1 + nebula2 * 0.5) / 1.5;
    nebula = (nebula + 1.0) * 0.5;

    // Add nebula color
    color = mix(color, uColorNebula, smoothstep(0.3, 0.7, nebula) * 0.6);
    color = mix(color, uColorAccent, smoothstep(0.5, 0.9, nebula) * 0.3);

    // Twinkling stars - multiple layers
    // Layer 1: Bright stars
    float starTime1 = floor(uTime * 2.0);
    vec3 starPos1 = pixelatedPos * 40.0 + vec3(starTime1 * 0.1);
    float stars1 = snoise(starPos1);
    float starShow1 = step(uStarDensity, (stars1 + 1.0) * 0.5);

    // Layer 2: Dim stars (more of them)
    float starTime2 = floor(uTime * 3.0);
    vec3 starPos2 = pixelatedPos * 60.0 + vec3(starTime2 * 0.15, starTime2 * 0.1, 0.0);
    float stars2 = snoise(starPos2);
    float starShow2 = step(uStarDensity - 0.02, (stars2 + 1.0) * 0.5);

    // Layer 3: Rare bright twinkles
    float starTime3 = floor(uTime * 5.0);
    vec3 starPos3 = pixelatedPos * 30.0 + vec3(starTime3 * 0.2);
    float stars3 = snoise(starPos3);
    float starShow3 = step(0.97, (stars3 + 1.0) * 0.5);

    // Combine star layers with different brightnesses
    color = mix(color, uColorStars * 0.5, starShow2 * 0.4);
    color = mix(color, uColorStars * 0.8, starShow1 * 0.7);
    color = mix(color, uColorStars * 1.2, starShow3);

    gl_FragColor = vec4(color, 1.0);
  `,
});
